<template>
    <div v-resize="onResize">
            
    <v-container fluid>
          <v-card>
              <v-layout class = "mr-5 mt-4">

        <h1 style="margin-left:15px; margin-top :20px;font-family:Verdana;font-size:16px"> <v-icon>mdi-map-marker-multiple</v-icon> Drop Off Point List</h1>
          <v-spacer></v-spacer>
        
          <v-spacer></v-spacer>

          <v-btn @click="openDialog()" rounded outlined style="margin-top :15px; margin-right :10px;font-family:Verdana"> 
                          <v-icon>mdi-map-marker-plus </v-icon>
                              Add New Drop Off Point
                        </v-btn>
        
      </v-layout>
        
    <v-container fluid>  
          <v-simple-table dense fixed-header :height="windowSize.y - 175 " style="margin-top :-10px" >
          <thead>
              <tr>
                  <th class="text-center" style="color:black;font-family:Verdana">Area</th>
                  <th class="text-center" style = "color:black;font-family:Verdana">Detail </th>
                  <th class="text-center" style = "color:black;font-family:Verdana"> InUse </th>
                  <th class="text-center" style = "color:black;font-family:Verdana">Action</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="item in DropOffList" :key="item.PlateNo">
                    <td class="text-center" style = "color:black;font-family:Verdana">{{item.PointNameArea}}</td> <!-- Drop Point Area -->
                    <td class="text-center" style = "color:black;font-family:Verdana">{{item.PointName}}</td> <!-- Drop point Detail-->
                      <td class="text-center" style = "color:black;font-family:Verdana">{{item.SelectUse}}</td>
                      <!-- <td class="text-center" style = "color:black;font-family:Verdana">{{item.useSpecial}}</td> -->
                      
                        <td class="text-center" style = "color:black;font-family:Verdana">
                          <v-tooltip bottom>
                            <template v-slot:activator= "{on}">

                          <v-btn v-on="on" elevation="0" x-small fab @click="editRec(item)">
                          <v-icon color="grey darken-1">mdi-pencil</v-icon>
                      </v-btn>
                          </template>
                          <span>Edit</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator= "{on}">
                      <v-btn v-on="on" elevation="0" x-small fab @click="deleteRec(item,item.pointID)">
                          <v-icon color="grey darken-1">mdi-trash-can-outline</v-icon>
                      </v-btn>
                      </template>
                        <span>Delete</span>
                      </v-tooltip>
                        </td>
                </tr>
              </tbody>
              </v-simple-table>
          
      </v-container>
      

      <v-dialog v-model = "dialog" persistent width="350px">
        <v-card>
            <v-toolbar dense color="#213c57" dark> <v-icon>mdi-information-outline</v-icon>
            <span style = "font-family: Verdana;font-size:15px; margin-left :5px " > Drop Off Point Information</span>
              <v-spacer></v-spacer>
              <v-btn icon @click = "closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container>
                <v-layout row>
                  <v-row>
                      <v-col>
                      
                    <v-autocomplete dense label="CARS Drop (Area)" v-model="toAdd.PointNameArea"  :items="DropOffArrs" outlined > </v-autocomplete>
                    <v-text-field v-model="toAdd.PointName" outlined label = "CARS Drop (Detail)" dense oninput="this.value = this.value.toUpperCase()" ></v-text-field>
                    
                      <v-select v-model="toAdd.SelectUse" :items = "SelectUse" dense outlined label = "In Use"></v-select>
                
                  </v-col>
                  </v-row>
                </v-layout>
              <v-layout>
              <v-spacer></v-spacer>

                <v-btn style = "margin-top:-25px" block @click = "addDropOff()" color="success"> {{btnName}} </v-btn>
              </v-layout>
              </v-container>
            </v-card-text>
        </v-card>
      </v-dialog>
      </v-card>
      </v-container>
      </div>
</template>

<script>

// import axios from 'axios'
import api from '../api.js'
import swal from 'sweetalert'
import _ from 'lodash'

export default {
    components:{

    },
    created(){
    this.loadDropOff()

    },
    data(){
        return{
        SelectUse :['Yes','No'],
        searchCar : '',
        dialog: false,
        DropOffList:[],
        toAdd:{},
        
        btnName: '',
        DropOffArrs : [
          'CAVITE',
          'PASAY',
          'MAKATI',
          'BGC'
        ]
      

        }
    },
    computed:{

    },

    methods: {
      openDialog(){
          this.dialog = true
          this.btnName = 'Add'
        },
        closeDialog(){
          this.dialog = false
          this.toAdd = {}
        },
        addDropOff(){
          if(this.btnName === 'Add'){
            let url = `${this.api}addDropOff`
              api.post(url, this.toAdd).then (res =>{
            // this.employeedata = res.data
              console.log(res.data)
                swal( "New Drop Point Added", " " , "success" , {
                      timer: 1000,
                      button:false
                    })
                this.loadDropOff()
              this.closeDialog()
                
          
          }) 
          }else {
            let url = `${this.api}updateDropOff`
              api.put(url, this.toAdd).then (res =>{
            // this.employeedata = res.data
              console.log(res.data)
              swal( "Drop Point has been updated", " " , "success" , {
                  timer: 1000,
                  button:false
                })
              this.loadDropOff()
              this.closeDialog()
          })
          }
          
        },
        loadDropOff(){
            let url =  `${this.api}getDropPoint`
          api.get(url).then( res =>{
          this.DropOffList = res.data.filter(rec =>{
            return rec.pointID !== '000001DONE'
          })

          this.DropOffList = _.orderBy(this.DropOffList, ['PointNameArea', 'PointName' ], ['ASC', 'ASC'])
          // this.timeSchedule = _.orderBy(res.data, ['timeSched'], ['ASC'])
        //  console.log(this.employeedata)
        }) 
        },

            editRec(rec){
            
            this.dialog = true
            this.btnName = 'Update'
            this.toAdd = rec
          
        },

        deleteRec(rec,pointID) {
          swal({
            title: 'Do you want to delete this Drop Point type?',
            icon : 'warning',
            closeOnEsc: false,
            closeOnClickOutside: false,
            buttons : [ 'No',  'Yes']
              
            }).then( (willApprove)=>{
              if (willApprove) {
                swal( "Drop Point has been deleted", " " , "error" , {
                  timer: 1000,
                  button:false
                })
                const index = this.DropOffList.indexOf(rec)
                
                this.DropOffList.splice(index,1)
                let url = `${this.api}deleteDropOff`
                api.post(url,{pointID:pointID}).then( res => {
                console.log(res.data)
                this.loadDropOff()
                }
                )
              }
          }) 
      },
    }
}


</script>
<style scoped>
table,th,td {
  border: 1px solid grey !important;
}
td{
  padding: 3px !important;
}

th{  
    background-color: #213c57 !important;
    color:white !important;
    font-family: Arial !important;
    padding:15px !important;
    font-size:13px;
}
tr:hover {
  background-color: #cdcdd1 !important;
}
</style>


